import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'
import {DialogContentText} from 'material-ui/Dialog'

import {email as styles} from '../styles'
import {email as text} from '../text'
import LoadingButton from '../../../common/components/LoadingButton'

class Email extends React.Component {

  render() {
    const {classes, email, isSending, isUpdating, error} = this.props
    return (
      <div>
        <Title classes={classes} text={text.title}/>
        {error
          ? <DialogContentText style={{color: 'red'}}>{error}</DialogContentText>
          :
          <div>
            <DialogContentText>{text.body1}</DialogContentText>
            <DialogContentText className={classes.email}>{email}</DialogContentText>
            <DialogContentText>{text.body2}</DialogContentText>
          </div>
        }
        <Actions
          classes={classes}
          buttonOne={{
            isLoading: isSending,
            isDisabled: false,
            onClick: () => this.props.sendConfirmationEmail(),
          }}
          buttonTwo={{
            isLoading: isUpdating,
            isDisabled: false,
            onClick: () => {
              this.props.updateMissingInfo()
            },
          }}
        />
      </div>
    )
  }

  static propTypes = {
    sendConfirmationEmail: PropTypes.func.isRequired,
    updateMissingInfo: PropTypes.func.isRequired,
    nextStep: PropTypes.func.isRequired,
    email: PropTypes.string,
    isSending: PropTypes.bool,
    isUpdating: PropTypes.bool,
    error: PropTypes.string,
  }
}

const Title = ({classes, text}) => (
  <div>
    <Typography variant="title" className={classes.dialogTitle}>{text}</Typography>
  </div>
)

const Actions = ({classes, buttonOne, buttonTwo}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="flat"
      color="default"
      onClick={buttonOne.onClick}
      disabled={buttonOne.isDisabled}
      isLoading={buttonOne.isLoading}
      className={classes.button}
    >
      {text.buttonResend}
    </LoadingButton>
    <LoadingButton
      variant="raised"
      color="primary"
      onClick={buttonTwo.onClick}
      disabled={buttonTwo.isDisabled}
      isLoading={buttonTwo.isLoading}
      className={classes.button}
    >
      {text.buttonContinue}
    </LoadingButton>
  </div>
)

export default withStyles(styles, {withTheme: true})(Email)



// WEBPACK FOOTER //
// ./src/sections/missingInfo/components/email.js